// covered-by: frontends/carrie/src/config/__tests__/askRouteTree.test.ts
import { createRouter } from "@tanstack/react-router";

import { selectChildRoutes } from "./askRouteTree";
import { BASEPATH } from "./env";

import { appRoutes, rootRoute } from "../routes";
import { NotFoundComponent } from "../routes/root/notFoundComponent";
import { queryClient } from "../utils/queryClient";

/**
 * Runtime still mounts V1 or V2 via `selectChildRoutes()`. Register is pinned
 * to the tickets tree so `Link to="/tickets"` type-checks — without the cast,
 * the V1|V2 union collapses `to` to the shared unauth paths and CI tsc fails.
 */
function createCarrieRouter(childRoutes: typeof appRoutes) {
  return createRouter({
    routeTree: rootRoute.addChildren(childRoutes),
    basepath: BASEPATH,
    context: {
      queryClient,
    },
    defaultNotFoundComponent: NotFoundComponent,
  });
}

export const router = createCarrieRouter(
  selectChildRoutes() as typeof appRoutes,
);

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof createCarrieRouter>;
  }
}

type TicketsPath = "/tickets";
const _assertTicketsRegistered: TicketsPath extends keyof (typeof router)["routesByPath"]
  ? true
  : never = true;
void _assertTicketsRegistered;
